import React, { useState } from "react";

import LongShortChart from "./LongShortChart";

const LongShortWithTabs = ({ labels, seriesData, name }) => {
  const [mainTabination, setMainTabination] = useState(1);

  return (
    <div className="LongShortWithTabs">
      <div className="chart_tabination">
        <button
          onClick={() => {
            setMainTabination(1);
          }}
          className={
            "chart_tabination_item " + (mainTabination === 1 && " active ")
          }
        >
          Win
        </button>

        <button
          onClick={() => {
            setMainTabination(2);
          }}
          className={
            "chart_tabination_item " + (mainTabination === 2 && " active ")
          }
        >
          Loss
        </button>
      </div>
      {mainTabination === 1 && (
        <LongShortChart labels={labels} seriesData={seriesData} name={name} />
      )}
      {mainTabination === 2 && (
        <LongShortChart labels={labels} seriesData={seriesData} name={name} />
      )}
    </div>
  );
};

export default LongShortWithTabs;
